import {SisName} from 'util/SisName';
import {AppName} from 'util/AppName';
import {PlanTemplateSisNameUrl} from 'appmodule/planTemplate/api/PlanTemplateAPI'
import {TERMINAL_BOOKING_URL, TERMINAL_PERSURL_URL} from 'appmodule/term/constants/TerminalUrlParamConst'

export const SisNameUrl = {
	[SisName.Booking]: '../json/booking',
	[SisName.Persurl]: '../json/persurl',
	[SisName.PlanTempl]: PlanTemplateSisNameUrl,
} as const
Object.freeze(SisNameUrl);

export const SisNameAppSpecificUrl: { [app in AppName]?: { [sisName in SisName]?: string } } = {
	[AppName.terminal]: {
		[SisName.Booking]: '../json/terminalPageController/evoTerminalBooking',
	},
	[AppName.term]: {
		[SisName.Booking]: TERMINAL_BOOKING_URL,
		[SisName.Persurl]: TERMINAL_PERSURL_URL,
	},
}
